import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { fetchJobseekersData } from 'features/jobseekers/jobseekersThunks';

import { Jobseeker, JobseekersList, JobseekersState } from 'types/jobseekers';

import { RequestStatus } from 'constants/enums';

const initialState: JobseekersState = {
  jobseekers: [],
  status: RequestStatus.Idle,
  error: null,
  count: 0
};

const jobseekersSlice = createSlice({
  name: 'jobseekers',
  initialState,
  reducers: {
    addJobseeker: (state, action: PayloadAction<Jobseeker>) => {
      state.jobseekers = [...state.jobseekers, action.payload];
    },
    updateJobseeker: (state, action: PayloadAction<Partial<Jobseeker>>) => {
      const { id, ...changes } = action.payload;
      state.jobseekers = state.jobseekers.map((jobseeker) =>
        jobseeker.id === id ? { ...jobseeker, ...changes } : jobseeker
      );
    },
    dropJobseekers: (state) => {
      state.jobseekers = [];
      state.count = 0;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobseekersData.pending, (state) => {
        state.status = RequestStatus.Loading;
      })
      .addCase(
        fetchJobseekersData.fulfilled,
        (state, action: PayloadAction<JobseekersList>) => {
          state.status = RequestStatus.Succeeded;
          state.jobseekers = action.payload.content;
          state.count = action.payload.totalElements;
          state.error = null;
        }
      )
      .addCase(fetchJobseekersData.rejected, (state, action) => {
        state.status = RequestStatus.Failed;
        state.error = action.error.message || null;
      });
  }
});

export const { addJobseeker, updateJobseeker, dropJobseekers } =
  jobseekersSlice.actions;

export default jobseekersSlice.reducer;
